import { useEffect } from 'react';
import { useSelector } from 'react-redux';

// Applies the persisted theme choice to the document root so CSS variables switch app-wide
const ThemeManager = () => {
    const mode = useSelector((state) => state.theme.mode);

    useEffect(() => {
        document.documentElement.classList.toggle('light', mode === 'light');
    }, [mode]);

    return null;
};

export default ThemeManager;
